import { render, staticRenderFns } from "./SportProgram.vue?vue&type=template&id=706b7377"
import script from "./SportProgram.vue?vue&type=script&lang=js"
export * from "./SportProgram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports